import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { PushNotificationProvider } from '@/components/common/PushNotificationProvider'
import { AppLockProvider } from '@/components/lock'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 2,
    },
  },
})

interface ProvidersProps {
  children: ReactNode
}

export function Providers({ children }: ProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <PushNotificationProvider>
        <AppLockProvider>
          {children}
        </AppLockProvider>
      </PushNotificationProvider>
    </QueryClientProvider>
  )
}
